import React, { Component } from 'react';
import clientApi from '../../api/client';
import successImg from '../../static/images/success_pay.png';
import failImg from '../../static/images/fail_pay.png';
import weixinfailImg from '../../static/images/weixinfail_pay.png';
import './appStyle.less';


class Success extends Component {
    render(){
        const {
            result,
            type,
            totalAmount,
            num,
            success,
            channel
        } = this.props
        return(
            <div className={result?"container success "+(type==='weixinfail'?'weixinfail':''):"container success "+type}>
                {!result &&
                    <div>
                        <img src={weixinfailImg} alt="图片"/>   
                        <div className="btn"
                            onClick={()=>{
                                clientApi.closeH5Page({reason:'closeSafe'})
                            }}
                        >已支付</div>
                    </div>
                    // :
                    // <div className="notice">
                    //     <div className="icon">温馨提示</div>
                    //     <div className="text">受春节物流停运影响, 实验套装寄送可能受到阻延,实际以【我的】中的物流信息为准。</div>
                    // </div>
                }
                {(type!=='weixinfail' && result) &&
                    <div className="top">
                        <div className="number">
                            <span>{totalAmount? totalAmount/100 : num}</span>元
                        </div>
                        <div className="text">{success?'支付成功':'支付失败'}</div>
                        <img src={success?successImg:failImg} alt="图片"/>
                    </div>
                }
                {(type==='weixinfail' && result) &&
                    <div>
                        <img src={weixinfailImg} alt="图片"/>   
                        <div className="text">未安装微信<br></br>请选择其他付款方式</div>
                        {/* <div className="btn" onClick={()=>{window.location.replace(`${window.location.origin}/pay/apppay?stuId=${stuId}`)}}>返回</div> */}
                    </div>
                }
                {(channel!=='others' && result) &&
                    // <div className="btn" onClick={()=>{handleBack()}}>返回</div>
                    <div 
                        className="btn" 
                        onClick={()=>{
                            clientApi.closeH5Page({reason:'closeSafe'})
                        }}
                    >完成</div>
                }
            </div>
            
        )
    }
}


export default Success;



// WEBPACK FOOTER //
// ./src/template/Pay/Success.jsx